// P08
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React, { useContext, useReducer } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviationFlagBase from './DeviationFlagBase';
import DailyDeviationFlag from './DailyDeviationCard';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import s from './DeviationFlags.scss';
const createFlagStateReducer = (isMobile)=>(state, action)=>{
        switch(action){
            case 'mouseEnter':
                return isMobile ? state : {
                    isFlagListVisible: true,
                    isHovering: true
                };
            case 'mouseLeave':
                return isMobile ? state : _object_spread_props(_object_spread({}, state), {
                    isHovering: false
                });
            case 'click':
                return isMobile ? state.isFlagListVisible ? _object_spread_props(_object_spread({}, state), {
                    isHovering: false
                }) : {
                    isFlagListVisible: true,
                    isHovering: true
                } : state;
            case 'transitionEnd':
                return state.isHovering ? state : _object_spread_props(_object_spread({}, state), {
                    isFlagListVisible: false
                });
            default:
                return state;
        }
    };
const DeviationFlags = ({ deviation: { dailyDeviation  } , alwaysExpanded , disableLabel , className  })=>{
    const { t  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const [{ isFlagListVisible , isHovering  }, dispatch] = useReducer(createFlagStateReducer(isMobile), {
        isFlagListVisible: false,
        isHovering: false
    });
    if (!dailyDeviation) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], alwaysExpanded && s['always-expanded'], isHovering && s['hovering'], isFlagListVisible && s['visible'], disableLabel && s['disable-label'], className),
        onClick: ()=>dispatch('click'),
        onMouseEnter: ()=>dispatch('mouseEnter'),
        onMouseLeave: ()=>dispatch('mouseLeave'),
        onTransitionEnd: (e)=>{
            if (e.propertyName === 'opacity') {
                dispatch('transitionEnd');
            }
        }
    }, /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        placement: "top",
        secondaryPlacement: isMobile ? 'end' : 'start',
        wrapperClassName: s['tooltip'],
        usePortal: false,
        eventsEnabled: isHovering,
        popoverContent: ({ placement  })=>/*#__PURE__*/ React.createElement("div", {
                className: classnames(s['flag-list'], s[placement], isFlagListVisible && s['flag-list-visible'])
            }, /*#__PURE__*/ React.createElement(DailyDeviationFlag, {
                dailyDeviation: dailyDeviation
            }))
    }, /*#__PURE__*/ React.createElement(DeviationFlagBase, {
        title: t(`actionbar.flags.dailyDeviation`)
    })));
};
DeviationFlags.displayName = 'DeviationFlags';
export default DeviationFlags;
